<template>
    <div class="cabinet">

        <h1>{{ data.value?.local?.title }}</h1>
        <div v-if="!data.value || !data.value.leads || false || data.value.leads.length === 0">
            <div class="empty">

                <div class="title">
                    {{ data.value?.local?.emptyTitle }}
                </div>
                <div class="text">
                    {{ data.value?.local?.emptyText }}
                </div>
                <div class="controls">
                    <a href="/public" class="mainButton">{{ data.value?.local?.comebackButton }}</a>
                </div>

            </div>
        </div>

        <div v-else>
            <div class="leadsCount">{{leadsCount}}</div>
            <button class="deleteAllLeads" @click="deleteLeadModal('all')">
                <span>{{ data.value?.local?.deleteAll }}</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M2.5 5H4.16667H17.5" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M6.66602 5.00002V3.33335C6.66602 2.89133 6.84161 2.4674 7.15417 2.15484C7.46673 1.84228 7.89065 1.66669 8.33268 1.66669H11.666C12.108 1.66669 12.532 1.84228 12.8445 2.15484C13.1571 2.4674 13.3327 2.89133 13.3327 3.33335V5.00002M15.8327 5.00002V16.6667C15.8327 17.1087 15.6571 17.5326 15.3445 17.8452C15.032 18.1578 14.608 18.3334 14.166 18.3334H5.83268C5.39065 18.3334 4.96673 18.1578 4.65417 17.8452C4.34161 17.5326 4.16602 17.1087 4.16602 16.6667V5.00002H15.8327Z" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M8.33398 9.16666V14.1667" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M11.666 9.16666V14.1667" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
            <ul class="leadList">
                <li v-for="(lead, index) in paginatedLeads" :key="index" class="lead">
                    <div class="head">
                        <div class="title">{{ data.value?.local?.lead }} {{lead.date}}</div>
                        <button class="deleteLead" @click="deleteLeadModal(lead.id)">
                            <span>{{ data.value?.local?.delete }}</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M15 5L5 15" stroke="#EB5757" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M5 5L15 15" stroke="#EB5757" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                    </div>
                    <div class="leadData" :class="{ expand: lead.expand }">
                        <template v-for="(value, key) in lead" :key="key">
                            <div v-if="key !== 'id' && key !== 'date' && key !== 'expand'" class="dataLine">
                                <div class="lineTitle">{{ key }}</div>
                                <div class="lineValue">{{ value }}</div>
                            </div>
                        </template>
                    </div>
                    <button
                        @click="toggleExpansion(lead)"
                        class="toggleButton"
                        :class="{ 'expanded': lead.expand, 'collapsed': !lead.expand }"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M5 7.5L10 12.5L15 7.5" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <span>{{lead.expand ? data.value?.local?.collapse : data.value?.local?.expand}}</span>
                    </button>
                </li>
            </ul>

            <div v-if="pageCount > 1" class="pagination">
                <button @click="changePage(-1)" :disabled="currentPage === 1" class="paginateBack">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M15 18L9 12L15 6" stroke="#BDBDBD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span>{{ data.value?.local?.backButton }}</span>
                </button>

                <div class="paginateButtons">
                    <template v-if="isWideScreen">
                        <button v-for="page in visiblePages" :key="page" @click="goToPage(page)" :disabled="currentPage === page" class="paginateButton">{{ page }}</button>
                    </template>
                    <template v-else>
                        <span>{{ currentPage }}/{{ pageCount }}</span>
                    </template>
                </div>

                <button @click="changePage(1)" :disabled="currentPage === pageCount" class="paginateForward">
                    <span>{{ data.value?.local?.nextButton }}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M9 18L15 12L9 6" stroke="#BDBDBD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
            </div>
        </div>
    </div>
</template>

<script setup>
import {onMounted, ref, reactive, computed, watchEffect} from "vue";
import {ajax, createLabel} from "@/assets/js/Functions";
import bus from '@/store/EventBus.js';
import '@/assets/css/form.css';

const data = reactive({})
const itemsPerPage = 5; // Количество элементов на странице
const currentPage = ref(1)

const leads = ref([])
const numberOfLeads = ref(0)
const leadsCount = ref(0)

const deleteLeadModal = (leadId = null) => {
    if(leadId === 'all') leadId = leads.value.map(lead => lead.id);
    bus.emit('showModal', {
        modalId: 'DeleteLead',
        params: {
            leadId: leadId,
            local: data.value?.local,
            images: data.value?.images
        }
    });
};

bus.on('updateLeads', () => getLeads());
onMounted(async () => getLeads());

function getLeads()
{
    ajax({
        action: "cabinet_get_leads"
    }, (response) => {
        data.value = response
        if(data.value.leads) leads.value = data.value.leads
    });
}

watchEffect(() => {
    numberOfLeads.value = leads.value.length
    if(data.value && data.value.local){
        leadsCount.value = numberOfLeads.value +' '+ createLabel(numberOfLeads.value, data.value.local.leadsCount)
    }
});

const changePage = (delta) => {
    currentPage.value += delta;
};

const goToPage = (page) => {
    currentPage.value = page;
};

const isWideScreen = computed(() => {
    return window.innerWidth >= 1024;
})

const paginatedLeads = computed(() => {
    const startIndex = (currentPage.value - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return data.value.leads.slice(startIndex, endIndex);
});

const pageCount = computed(() => Math.ceil(data.value.leads.length / itemsPerPage));
const toggleExpansion = (lead) => {
    lead.expand = !lead.expand;
};
const visiblePages = computed(() => {
    const totalPages = pageCount.value;
    const currentPageValue = currentPage.value;

    const range = 2; // Регулирует количество видимых страниц в каждую сторону от текущей страницы.

    let startPage = Math.max(currentPageValue - range, 1);
    let endPage = Math.min(currentPageValue + range, totalPages);

    const pages = [];

    if (startPage > 1) {
        pages.push(1);
        if (startPage > 2) {
            pages.push('...');
        }
    }

    for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
    }

    if (endPage < totalPages) {
        if (endPage < totalPages - 1) {
            pages.push('...');
        }
        pages.push(totalPages);
    }

    return pages;
})





</script>

<style>
button{
    cursor: pointer;
}
h1{
    color: #333;
    font-size: 35px;
    font-weight: 700;
    margin: 0 0 20px;
}
.leadsCount{
    color: #4F4F4F;
    font-size: 14px;
    font-weight: 500;
    width: auto;
    text-align: left;
    margin: 0 0 20px;
}
.deleteAllLeads{
    color: #333;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    display: inline-flex;
    height: 36px;
    padding: 10px 12px;
    justify-content: center;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
    border-radius: 6px;
    border: 1px solid #333;
    background: #fff;
    margin: 0 0 30px;
}
.deleteAllLeads svg{
    width: 20px;
    height: 20px;
}
.leadList{
    list-style: none;
    padding: 0;
    margin: 0;
}
.leadList .lead{
    display: flex;
    padding: 30px 20px;
    flex-direction: column;
    align-items: flex-start;
    gap: 30px;
    border-radius: 10px;
    background: #FFF;
    box-shadow: 0 0 14px 0 rgba(102, 111, 116, 0.20);
}
.leadList .lead:not(:last-child){
    margin-bottom: 20px;
}
.leadList .lead .head{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}
.leadList .lead .title{
    color: #333;
    font-size: 22px;
    font-weight: 600;
}
.leadList .lead .deleteLead{
    display: flex;
    height: 36px;
    padding: 10px 12px;
    justify-content: center;
    align-items: center;
    gap: 6px;
    border-radius: 6px;
    border: 1px solid #EB5757;
    background: #FFF;
}
.leadList .lead .deleteLead svg{
    width: 20px;
    height: 20px;
}
.leadData{
    width: 100%;
    overflow: hidden;
    position: relative;
    max-height: 400px;
    transition:  max-height 200ms ease-in-out;
}
.leadData:after{
    content: '';
    display: block;
    position: absolute;
    height: 260px;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgb(255,255,255);
    background: linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 60%);
}
.leadData.expand{
    max-height: 2000px;
}
.leadData.expand:after{
    display: none;
}
.dataLine{
    display: flex;
    padding: 16px 0;
    justify-content: space-between;
    align-items: flex-start;
    align-self: stretch;
    border-bottom: 1px solid #E0E0E0;
}
.dataLine .lineTitle{
    color: #828282;
    font-size: 14px;
    font-weight: 500;
}
.dataLine .lineValue{
    color: #333;
    text-align: right;
    font-size: 14px;
    font-weight: 500;
}
.dataLine:first-child{
    border-top: 1px solid #E0E0E0;
}
.toggleButton{
    display: flex;
    height: 40px;
    padding: 20px;
    justify-content: center;
    align-items: center;
    gap: 6px;
    color: #333;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    border-radius: 6px;
    border: 1px solid #BDBDBD;
    background: #fff;
    margin: auto;
}
.toggleButton svg{
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    transition: transform 200ms ease-in-out;
}
.toggleButton.expanded svg{
    transform: rotate(180deg);
}
.pagination {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 14px;
    margin: 40px 40px 0 auto;
    width: auto;
    position: relative;
    flex-wrap: wrap;
}
.paginateButtons{
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 2px;
}
.paginateButton{
    display: flex;
    width: 34px;
    height: 34px;
    padding: 1px 3px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border: 0;
    background: transparent;
    color: #4F4F4F;
    text-align: center;
    font-size: 18px;
    font-weight: 500;
}
.paginateButton:disabled{
    border-radius: 50%;
    background: #D9D9D9;
}
.paginateBack, .paginateForward {
    display: flex;
    gap: 6px;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: 0;
    color: #BDBDBD;
    font-size: 16px;
    font-weight: 500;
}
.paginateBack:not(:disabled) svg path, .paginateForward:not(:disabled) svg path{
    stroke: var(--color-primary);
}
.paginateBack:not(:disabled), .paginateForward:not(:disabled) {
    color: var(--color-primary);
}
.empty {
    display: flex;
    flex-direction: column;
    gap: 20px;
    text-align: center;
    max-width: 400px;
    margin: 100px auto 50px;
}
.empty .title{
    color: #333;
    font-size: 28px;
    font-weight: 700;
}
.empty .text{
    color: #333;
    text-align: center;
    font-size: 18px;
    font-weight: 500;
}

@media all and (max-width: 768px) {
    h1{
        font-size: 22px;
    }
    .leadList .lead .title {
        font-size: 18px;
    }
    .leadList .lead .head {
        flex-direction: column;
        align-items: flex-start;
        gap: 30px;
    }
    .leadData {
        max-height: 250px;
    }
    .pagination {
        justify-content: space-between;
        margin: 30px auto;
    }
    .paginateButtons{
        border-radius: 26px;
        background: #E0E0E0;
        padding: 5px 13px;
        gap: 10px;
        flex-shrink: 0;
        color: #4F4F4F;
        font-size: 18px;
        font-weight: 500;
    }
    .empty .title{
        font-size: 18px;
        font-weight: 600;
    }
    .empty .text{
        font-size: 14px;
    }
}
</style>
